import React, { type FC } from 'react';
import { useTranslations } from '@vocab/react';
import {
  Box,
  ContentBlock,
  Tab,
  Tabs,
  TabsProvider,
} from 'braid-design-system';
import translations from './.vocab';
import {
  URL_LIST_JOBS_DRAFT,
  URL_LIST_JOBS_EXPIRED,
  URL_LIST_JOBS_OPEN,
} from '@seek/adv-constants';
import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';

export const FilterSection: FC = () => {
  const { t } = useTranslations(translations);
  const { router } = useAppConfig();

  const currentTabItem = 'your-candidates';
  return (
    <Box background="surface" paddingX="small">
      <ContentBlock width="large">
        <Box paddingTop="medium">
          <TabsProvider
            id="job-tabs"
            selectedItem={currentTabItem}
            onChange={(_, selectedItemUrl) => {
              if (selectedItemUrl && selectedItemUrl !== currentTabItem) {
                // TODO: This is needed because not sure how to use `Link` in a `Tab.
                // Need help from Braid friends.
                window.location.assign(
                  router.urlResolver({ path: selectedItemUrl }),
                );
              }
            }}
          >
            <Tabs label="Job type filter" divider="none">
              <Tab item={URL_LIST_JOBS_OPEN}>{t('Open')}</Tab>
              <Tab item={URL_LIST_JOBS_EXPIRED}>{t('Expired')}</Tab>
              <Tab item={URL_LIST_JOBS_DRAFT}>{t('Draft')}</Tab>
              <Tab item={currentTabItem}>{t('Your candidates')}</Tab>
            </Tabs>
          </TabsProvider>
        </Box>
      </ContentBlock>
    </Box>
  );
};
